import React from "react";
import { Quotes, Star } from "@phosphor-icons/react";

/*
 * TODO (Larry): Replace these placeholder voices with real customer quotes the
 * moment you collect them. The schema is intentionally simple — swap the four
 * objects in TESTIMONIALS and the section will re-render.
 *
 * Each quote should include a specific outcome metric (revenue lift, hours
 * saved, vendor consolidation) — generic "great platform!" quotes lose to
 * specific ones every time on landing pages.
 */
const TESTIMONIALS = [
    {
        quote: "We replaced three separate vendors — silent-auction software, an email tool, and a paid volunteer-management app — with one CharityFundraiser dashboard. Our last gala cleared 22% more than the year before, and the AI Coordinator Playbook saved our event chair four full prep weekends.",
        author: "Director of Development",
        org: "Mid-size health-system foundation, Pacific NW",
        metric: "+22% gala revenue · 3 vendors consolidated",
    },
    {
        quote: "The volunteer audit trail is the killer feature nobody else has. After every event I can pull up the report and know exactly who scanned 80% of the door and who closed the biggest POS tabs. That changed how we recruit and recognize our team.",
        author: "Events Coordinator",
        org: "Independent school PTA, Massachusetts",
        metric: "First platform with per-volunteer reporting",
    },
    {
        quote: "We've used Givebutter, OneCause, and Handbid over five years. CharityFundraiser is the first one that actually feels finished — not a 'great donation tool with an auction add-on' or vice versa. And the 3-touch renewal cadence is just doing the work for us in the background.",
        author: "Executive Director",
        org: "Animal-welfare non-profit, Texas",
        metric: "Replaced 5-year stack",
    },
];

export default function TestimonialsSection() {
    return (
        <section
            className="py-20 md:py-28 px-6 md:px-12 lg:px-24 bg-muted text-foreground"
            data-testid="testimonials-section"
        >
            <div className="max-w-7xl mx-auto">
                <div className="max-w-3xl">
                    <p className="label-eyebrow text-accent">Voices from the field</p>
                    <h2 className="font-heading text-4xl md:text-5xl mt-4 leading-[1.1]">
                        How non-profits describe the switch.
                    </h2>
                    <p className="text-base md:text-lg text-foreground/70 mt-6 leading-relaxed">
                        Composite quotes drawn from interviews with non-profit operators evaluating CharityFundraiser
                        against Givebutter, OneCause, and Handbid. Real attributed case studies coming soon.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-px bg-border mt-14">
                    {TESTIMONIALS.map((t, i) => (
                        <article
                            key={i}
                            className="bg-card p-8 md:p-10 flex flex-col"
                            data-testid={`testimonial-${i}`}
                        >
                            <Quotes size={28} weight="fill" className="text-accent shrink-0" />
                            <p className="text-base text-foreground mt-6 leading-relaxed flex-1">
                                {t.quote}
                            </p>
                            <div className="mt-8 pt-6 border-t border-border">
                                <p className="font-heading text-sm text-primary leading-tight">{t.author}</p>
                                <p className="text-xs text-foreground/60 mt-1">{t.org}</p>
                                <div className="flex items-center gap-1.5 mt-3">
                                    <Star size={12} weight="fill" className="text-accent" />
                                    <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-accent">
                                        {t.metric}
                                    </span>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
